import React from "react";
import "../css/Portfolio.scss";

const Portfolio = () => {
  const handleClick = (myLink: string) => {
    window.location.href = myLink;
  };

  return (
    <div className="portfolio">
      <h1 className="title">My Projects</h1>
      <div className="btn">
        {/* <div className="bt1">
          <a href="" className="bt1">
            Legal Services Website
          </a>
          <p>
            I contacted a local pizza restaurant and collaborated with them to
            create a website where customers could see the menu and information
            about the restaurant. It showed that I could collaborate with
            others, which is a very valuable thing to have in your portfolio.
          </p>
          <p>Built with: React, Materialize CSS framework, Firebase</p>
        </div> */}
        {/* <a href="https://accept-me.web.app/" className="bt1"></a> */}
        <button
          className="bt1"
          onClick={() => handleClick("https://accept-me.web.app/")}>
          Legal Services Website
        </button>
        <button
          className="bt2"
          onClick={() => handleClick("https://bookstore-7cda5.web.app")}>
          Bookstore
        </button>
        <button
          className="bt3"
          onClick={() => handleClick("https://netflix-cb0ba.web.app/")}>
          Netflix
        </button>
        <button
          className="bt4"
          onClick={() => handleClick("https://sunnyside-e0635.web.app/")}>
          Vite+React
        </button>
      </div>
    </div>
  );
};

export default Portfolio;
